import { render, staticRenderFns } from "./SendBluffsModal.vue?vue&type=template&id=70a587d2&scoped=true"
import script from "./SendBluffsModal.vue?vue&type=script&lang=js"
export * from "./SendBluffsModal.vue?vue&type=script&lang=js"
import style0 from "./SendBluffsModal.vue?vue&type=style&index=0&id=70a587d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a587d2",
  null
  
)

export default component.exports